var a = /* @__PURE__ */ ((r) => (r["12px"] = "12", r["16px"] = "16", r["20px"] = "20", r["24px"] = "24", r["32px"] = "32", r["48px"] = "48", r))(a || {}), l = /* @__PURE__ */ ((r) => (r["12px"] = "extra-small", r["16px"] = "small", r["24px"] = "medium", r["48px"] = "large", r))(l || {});
const o = {
  "extra-small": "12",
  small: "16",
  medium: "24",
  large: "48"
}, x = (r) => o[r] ?? r, p = 48, t = [
  "primary",
  "secondary",
  "success",
  "info",
  "danger",
  "warning"
], c = ["small", "medium", "large"];
export {
  p as RAW_DIMENSION,
  l as SizeNamesEnum,
  a as SizesEnum,
  x as getSize,
  t as iconColors,
  c as iconSizes,
  o as sizeNameToSize
};
